// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glyph-selection {
  width: 100%;
  text-align: left; /* Центрируем содержимое */
}

.glyph-options {
  display: flex;
  justify-content: center; /* Центрируем кнопку выбора глифа */
  flex-wrap: wrap;
}

.glyph-option {
  position: relative; /* Для позиционирования текста внутри кнопки */
  width: 100px; /* Увеличенный размер для большей заметности */
  height: 100px;
  background: none;
  color: var(--tg-theme-text-color);
  border: 5.7px solid;
  border-color: rgba(115, 185, 255, 0.3);
  border-radius: 12px;
  padding: 7px;
  cursor: pointer;
  margin: 10px; /* Увеличенный отступ для центрирования */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  box-sizing: border-box;
  transition: all 0.2s ease; /* Плавные переходы для эффектов */
}

.glyph-option.active {
  color: var(--tg-theme-button-color);
  border-color: var(--tg-theme-button-color);
  opacity: 1;
}

.glyph-option:hover {
  background-color: rgba(154, 154, 154, 0.12);
  border-color: var(--tg-theme-button-color);
  opacity: 1;
}

.glyph-option canvas {
  border-radius: 5px;
  width: 80px; /* Размер канваса внутри кнопки */
  height: 80px;
  display: block;
}

/* Стили для миниатюр в истории */
.glyph-history {
  text-align: center;
}

.glyph-history-options {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.glyph-history-option {
  position: relative;
  width: 45px; /* Меньший размер для миниатюр */
  height: 45px;
  background: none;
  color: var(--tg-theme-text-color);
  border: 3px solid;
  border-color: rgba(115, 185, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  margin: 5px; /* Меньший отступ */
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.glyph-history-option:hover {
  background-color: rgba(154, 154, 154, 0.12);
  border-color: var(--tg-theme-button-color);
  opacity: 1;
}

.glyph-history-option canvas {
  border-radius: 5px;
  width: 38px; /* Меньший размер канваса внутри миниатюры */
  height: 38px;
  display: block;
}

/* Новые стили для кнопок "копировать" и "вставить" */

/* Контейнер для основного глифа и кнопок */
.glyph-option-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* Общие стили для кнопок действий */
.glyph-action-button {
  width: 30px;
  height: 30px;
  background: none;
  border: 2px solid rgba(115, 185, 255, 0.3);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-theme-text-color);
  opacity: 0.7;
  transition: all 0.2s ease;
  margin: 0 10px; /* Отступы от глифа */
}

.glyph-action-button:hover {
  background-color: rgba(154, 154, 154, 0.12);
  border-color: var(--tg-theme-button-color);
  opacity: 1;
}

/* Иконки внутри кнопок */
.glyph-action-button svg {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/menus/brush/GlyphSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,mCAAmC;EAC5D,eAAe;AACjB;;AAEA;EACE,kBAAkB,EAAE,8CAA8C;EAClE,YAAY,EAAE,8CAA8C;EAC5D,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY,EAAE,yCAAyC;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,iCAAiC;EAC9C,YAAY;EACZ,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,gCAAgC;EAC7C,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,WAAW,EAAE,mBAAmB;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,4CAA4C;EACzD,YAAY;EACZ,cAAc;AAChB;;AAEA,qDAAqD;;AAErD,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,yBAAyB;EACzB,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".glyph-selection {\r\n  width: 100%;\r\n  text-align: left; /* Центрируем содержимое */\r\n}\r\n\r\n.glyph-options {\r\n  display: flex;\r\n  justify-content: center; /* Центрируем кнопку выбора глифа */\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.glyph-option {\r\n  position: relative; /* Для позиционирования текста внутри кнопки */\r\n  width: 100px; /* Увеличенный размер для большей заметности */\r\n  height: 100px;\r\n  background: none;\r\n  color: var(--tg-theme-text-color);\r\n  border: 5.7px solid;\r\n  border-color: rgba(115, 185, 255, 0.3);\r\n  border-radius: 12px;\r\n  padding: 7px;\r\n  cursor: pointer;\r\n  margin: 10px; /* Увеличенный отступ для центрирования */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.7;\r\n  box-sizing: border-box;\r\n  transition: all 0.2s ease; /* Плавные переходы для эффектов */\r\n}\r\n\r\n.glyph-option.active {\r\n  color: var(--tg-theme-button-color);\r\n  border-color: var(--tg-theme-button-color);\r\n  opacity: 1;\r\n}\r\n\r\n.glyph-option:hover {\r\n  background-color: rgba(154, 154, 154, 0.12);\r\n  border-color: var(--tg-theme-button-color);\r\n  opacity: 1;\r\n}\r\n\r\n.glyph-option canvas {\r\n  border-radius: 5px;\r\n  width: 80px; /* Размер канваса внутри кнопки */\r\n  height: 80px;\r\n  display: block;\r\n}\r\n\r\n/* Стили для миниатюр в истории */\r\n.glyph-history {\r\n  text-align: center;\r\n}\r\n\r\n.glyph-history-options {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.glyph-history-option {\r\n  position: relative;\r\n  width: 45px; /* Меньший размер для миниатюр */\r\n  height: 45px;\r\n  background: none;\r\n  color: var(--tg-theme-text-color);\r\n  border: 3px solid;\r\n  border-color: rgba(115, 185, 255, 0.3);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  margin: 5px; /* Меньший отступ */\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.8;\r\n  box-sizing: border-box;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.glyph-history-option:hover {\r\n  background-color: rgba(154, 154, 154, 0.12);\r\n  border-color: var(--tg-theme-button-color);\r\n  opacity: 1;\r\n}\r\n\r\n.glyph-history-option canvas {\r\n  border-radius: 5px;\r\n  width: 38px; /* Меньший размер канваса внутри миниатюры */\r\n  height: 38px;\r\n  display: block;\r\n}\r\n\r\n/* Новые стили для кнопок \"копировать\" и \"вставить\" */\r\n\r\n/* Контейнер для основного глифа и кнопок */\r\n.glyph-option-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n/* Общие стили для кнопок действий */\r\n.glyph-action-button {\r\n  width: 30px;\r\n  height: 30px;\r\n  background: none;\r\n  border: 2px solid rgba(115, 185, 255, 0.3);\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--tg-theme-text-color);\r\n  opacity: 0.7;\r\n  transition: all 0.2s ease;\r\n  margin: 0 10px; /* Отступы от глифа */\r\n}\r\n\r\n.glyph-action-button:hover {\r\n  background-color: rgba(154, 154, 154, 0.12);\r\n  border-color: var(--tg-theme-button-color);\r\n  opacity: 1;\r\n}\r\n\r\n/* Иконки внутри кнопок */\r\n.glyph-action-button svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
